import { Wording } from '@/types';

export const COOKING_WORDING_SK: Wording = {
  components_header_media_content: 'Videá o varení',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recepty',
  components_header_text2: 'Blog',
  components_header_members: 'Členovia',
  hero_text: 'Varte s vášňou, jedzte s radosťou',
  hero_button_text: 'Začnite variť ešte dnes',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text: 'Všetky zdroje, ktoré potrebujete na učenie sa, varenie a vytváranie lepšieho jedla',
  components_ressources_span_text: 'Objavte bohatú zbierku videoreceptov, podrobných návodov na varenie a odborných postrehov o párovaní chutí, prezentácii jedál a kulinárskej kreativite.',
  components_ressources_card_1_title: 'Inšpirácia na varenie',
  components_ressources_card_1_text: 'Nechajte sa inšpirovať kreatívnymi receptami a kuchárskymi videami.',
  components_ressources_card_2_title: 'Vedomosti o varení',
  components_ressources_card_2_text: 'Naučte sa základné techniky varenia, kombinácie chutí a základy párovania jedál prostredníctvom jasných a praktických návodov.',
  components_ressources_link: 'Pozrite si videá',
  components_notes_and_google_title_1: 'Vzdelávanie v oblasti varenia',
  components_notes_and_google_title_2: 'Každodenné varenie',
  components_notes_and_google_title_3: 'Konzistentné kuchárske zručnosti',
  components_review_google_text: 'Recenzie na Googli',
  media_content_section_title: 'Videá o varení',
  media_content_section_subheader_text: 'Preskúmajte recepty a podrobné videá s návodmi na varenie.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Viac videí',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Sprievodcovia a články',
  text2_section_button_more: 'Ďalšie články',
  components_text1_section_title: 'RECEPTY',
  components_text1_subheader_text: 'Lahodné recepty na každodenné varenie',
  components_text1_span_text: 'Objavte ľahko sledovateľné recepty určené na každodenné jedlá, jasné kroky a skvelé výsledky.',
  components_text1_card_1_title: 'Začnite svoj deň správne',
  components_text1_card_1_text: 'Jednoduché a chutné recepty na ľahký a chutný začiatok dňa.',
  components_text1_card_3_title: 'Nápady na chutný obed',
  components_text1_card_3_text: 'Chutné recepty na obed, ktoré sa ľahko pripravujú a sú plné chuti.',
  components_text1_card_2_title: 'Recepty na upokojujúcu večeru',
  components_text1_card_2_text: 'Teplé a sýte recepty na večeru, ideálne na uvoľnené večery doma.',
  components_text1_link: 'Zobraziť všetky recepty',
  components_footer_text: 'Naučte sa lepšie variť, tvorte lepšie jedlo: Vaša kuchyňa, vaša cesta.',
  components_footer_info: 'Informácie',
  components_footer_registration_number: 'Registračné číslo',
  components_footer_legal: 'Právne',
  components_footer_terms: 'Zmluvné podmienky',
  components_footer_privacy: 'Zásady ochrany osobných údajov',
  button_load_more: 'Načítať viac',
  page_media_1_content_hero_text: 'Objavte jednoduché videá o varení pre každý vkus',
  page_text1_hero_text: 'Recepty',
  page_text1_section_title: 'Tipy na varenie',
  page_text1_subheader_text: 'Recepty',
  page_text2_hero_text: 'Náš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Sprievodcovia a články',
  enter_email_title: 'Pre pokračovanie zadajte svoj e-mail',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Zadajte',
  components_login_success_text: 'Prihlásenie úspešné!',
  components_card_link_media_content: 'Pozrite si teraz',
  components_card_link_text1_content: 'Zobraziť recept',
  components_card_link_text2_content: 'Zobraziť článok',
};